import { ActiveModes, Address } from '@checkout-v2/const';
import { MemoizedSelector, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CustomCheckoutState, StateWithCustomCheckout } from '../checkout-state';
import { getActiveModes } from './checkout.selector';
import { getCustomCheckoutState } from './feature.selector';

export const getAddressListState: MemoizedSelector<
  StateWithCustomCheckout,
  StateUtils.LoaderState<Address[]>
> = createSelector(getCustomCheckoutState, (state: CustomCheckoutState) => state.addressList);

export const getAddressList: MemoizedSelector<StateWithCustomCheckout, Address[]> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderValueSelector(state.addressList),
);

export const getAddressListLoading: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderLoadingSelector(state.addressList),
);

export const getAddressListSuccess: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderSuccessSelector(state.addressList),
);

export const getActiveAddressId: MemoizedSelector<StateWithCustomCheckout, string | undefined> = createSelector(
  getActiveModes,
  (activeModes: ActiveModes) => activeModes.addressId,
);

export const getActiveAddress: MemoizedSelector<StateWithCustomCheckout, Address | undefined> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => {
    const activeAddressId = state.activeModes.addressId;
    const addressList = StateUtils.loaderValueSelector(state.addressList) ?? [];

    return addressList.find((address) => address.id === activeAddressId);
  },
);

export const getIsActiveAddressHasNoFloor: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getActiveAddress,
  (address) => !!address && !address.privateHouse && !address.floor,
);
